// extracted by mini-css-extract-plugin
export default {"overlay":"wx-z","bodyOpen":"xx-z","content":"yx-z","header":"zx-z","close":"Ax-z","closeNoHeading":"Bx-z"};